import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
`;

export const TitleContainer = styled.div`
	> div.kog-area-textToCopy {
		display: inline;
	}
`;
